<ion-app>
  <ion-menu contentId="myMenuContent" id="myMenu" (ionWillOpen)="validateChatIsOpen()" [swipeGesture]="false">
    <csi-mobilemenu (sendNav)="onTypeEmitted($event)" [activeMenuItem]="activeMenuItem" [civarMenu]="civarMenu"
      [quantumCivarMenu]="quantumCivarMenu"></csi-mobilemenu>
  </ion-menu>

  @if (isAuth) {
  <csi-menuLat (sendNav)="onTypeEmitted($event)" [civarMenu]="civarMenu" [quantumCivarMenu]="quantumCivarMenu"
    [quantronActive]="chatQuantronAccessInfo.access" [hidden]="!showMenuLatDesktop"></csi-menuLat>
  }

  <ion-router-outlet id="myMenuContent" [hidden]="!isOutSplashScreen">
  </ion-router-outlet>

  @if (isAuth) {
  <chat-ai-popup [quantronAccessInfo]="chatQuantronAccessInfo" [hidden]="!showChatAIPopup"></chat-ai-popup>
  }
</ion-app>